export var CampaignAction;
(function (CampaignAction) {
    CampaignAction["PAUSE"] = "pause";
    CampaignAction["RESUME"] = "resume";
    CampaignAction["VIEW"] = "view";
    CampaignAction["RENAME"] = "rename";
    CampaignAction["DUPLICATE"] = "duplicate";
    CampaignAction["DELETE"] = "delete";
})(CampaignAction || (CampaignAction = {}));
export var isNewCustomersGroup = function (group) {
    return group.name === 'new';
};
export var isServiceCustomersGroup = function (group) {
    return group.name === 'service';
};
export var isBarberCustomersGroup = function (group) {
    return group.name === 'barber';
};
export var isShopCustomersGroup = function (group) {
    return group.name === 'shop';
};
export var CUSTOMER_GROUP_NAME = {
    regular: 'regular',
    lapsing: 'lapsing',
    prospective: 'prospective',
    all: 'all',
    new: 'new',
    service: 'service',
    barber: 'barber',
    shop: 'shop',
};
export var PromoRuleType;
(function (PromoRuleType) {
    PromoRuleType[PromoRuleType["CERTAIN_DAY"] = 0] = "CERTAIN_DAY";
    PromoRuleType[PromoRuleType["EVERY_X_DAYS"] = 1] = "EVERY_X_DAYS";
    PromoRuleType[PromoRuleType["ONE_TIME_WITH_EXP_DATE"] = 2] = "ONE_TIME_WITH_EXP_DATE";
    PromoRuleType[PromoRuleType["CERTAIN_SHOP"] = 3] = "CERTAIN_SHOP";
    PromoRuleType[PromoRuleType["CERTAIN_SHOP_AND_BARBER"] = 4] = "CERTAIN_SHOP_AND_BARBER";
    PromoRuleType[PromoRuleType["NEW_CUSTOMERS_ONLY"] = 5] = "NEW_CUSTOMERS_ONLY";
    PromoRuleType[PromoRuleType["ONE_TIME_CODE"] = 6] = "ONE_TIME_CODE";
    PromoRuleType[PromoRuleType["X_USAGES"] = 7] = "X_USAGES";
})(PromoRuleType || (PromoRuleType = {}));
